"use client";

import type { PublicPacket } from "@repo/api/use-cases/assessments/public-board";

import { BriefSections } from "@/components/assessments/brief-sections";
import { scoringRules } from "@/lib/assessments/scoring-rules";

/**
 * The packet, as somebody deciding whether to sit it reads it.
 *
 * The same sections a participant gets, from the same component, because there
 * is one packet and two audiences for it rather than two packets. What is
 * missing is the artefact itself: a material carries no `url` here, so each row
 * says it opens with the task instead of linking to a file somebody could work
 * through before arriving.
 */
export function ExamPanel({ packet }: { packet: PublicPacket | null }) {
  if (!packet) {
    return (
      <p className="assess-p text-marketing-text-muted mx-auto max-w-[760px]">
        The brief for this assessment is not available right now.
      </p>
    );
  }

  return (
    <div className="mx-auto max-w-[760px]">
      {/* The tab opened on a row of collapsed headings and a control to expand
          them, which says what to click and never what any of it is. */}
      <div className="mb-9">
        <h2 className="assess-h2 text-marketing-text">
          What this assessment gives you
        </h2>
        <p className="assess-sub text-marketing-text-muted mt-2 max-w-[560px]">
          The brief, the material, the scoring rules and everything already
          published. The same packet a participant reads before they begin.
        </p>
      </div>

      <BriefSections
        brief={packet.brief}
        materials={packet.materials.map((file) => ({ name: file.name }))}
        prelist={packet.prelist}
        rules={scoringRules(packet)}
      />
    </div>
  );
}
